// extracted by mini-css-extract-plugin
export default {"container":"TabGroup_container__+Osh5","tabs":"TabGroup_tabs__jNPcI","tab":"TabGroup_tab__9XVGt","tab-active":"TabGroup_tab-active__7Kxkt"};